
# Constants
exports.UPLOAD_MEDIA_FROM_SOURCE = 'UPLOAD_MEDIA_FROM_SOURCE'
exports.UPLOAD_MEDIA_FROM_SOURCE_SUCCESS = 'UPLOAD_MEDIA_FROM_SOURCE_SUCCESS'
exports.UPLOAD_MEDIA_FROM_SOURCE_FAILURE = 'UPLOAD_MEDIA_FROM_SOURCE_FAILURE'
exports.UPLOAD_MEDIA_FROM_SOURCE_PROGRESS = 'UPLOAD_MEDIA_FROM_SOURCE_PROGRESS'
exports.UPLOAD_MEDIA_FROM_SOURCE_PREVIEW = 'UPLOAD_MEDIA_FROM_SOURCE_PREVIEW'

exports.POST_MEDIA_FOR_SLIDE = 'POST_MEDIA_FOR_SLIDE'
exports.POST_MEDIA_FOR_SLIDE_SUCCESS = 'POST_MEDIA_FOR_SLIDE_SUCCESS'
exports.POST_MEDIA_FOR_SLIDE_FAILURE = 'POST_MEDIA_FOR_SLIDE_FAILURE'

exports.GET_MEDIA_FOR_SLIDE = 'GET_MEDIA_FOR_SLIDE'
exports.GET_MEDIA_FOR_SLIDE_SUCCESS = 'GET_MEDIA_FOR_SLIDE_SUCCESS'
exports.GET_MEDIA_FOR_SLIDE_FAILURE = 'GET_MEDIA_FOR_SLIDE_FAILURE'

exports.COMMENT_ADDED = 'COMMENT_ADDED'
exports.UNSET_AUTO_OPEN_COMMENT = 'UNSET_AUTO_OPEN_COMMENT'